import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { hiddenEventsList } from "../../../services/api";
import { updateState } from "../../../redux/commonSlice";
import { showSnackBar } from "../../../utils/commonServices";

/**
 * The archived list is kept in local state, not in commonReducer: the dashboard
 * owns events / combined_filter / status_filtered_events / type_filtered_events
 * and writing the archived list into those keys would corrupt it when the user
 * navigates back.
 *
 * archived_count is the one thing that does belong in redux - the dashboard link
 * reads it.
 */
export default () => {
  const dispatch = useDispatch();
  const [archivedEvents, setArchivedEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchArchivedEvents = useCallback(() => {
    setIsLoading(true);
    return hiddenEventsList()
      .then((response) => {
        if (response?.data?.http_code === 200) {
          const events = response?.data?.data?.event_details || [];
          setArchivedEvents(events);
          dispatch(updateState({ archived_count: response?.data?.data?.hidden_count || 0 }));
        } else {
          showSnackBar(dispatch, response?.data);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        showSnackBar(dispatch, error?.response?.data);
        setIsLoading(false);
      });
  }, [dispatch]);

  useEffect(() => {
    fetchArchivedEvents();
  }, [fetchArchivedEvents]);

  return [archivedEvents, isLoading, fetchArchivedEvents];
};
